import * as constants from './constants'
import { newRuleModel, participantAction } from './models'
import { Map } from 'immutable'
import { combineReducers } from 'redux-immutable'
import { handleActions } from 'redux-actions'
import * as actions from './actions'

const rules = handleActions(
  {
    [actions.fetchRulesSuccess]: (state, action) => action.payload.rules,
  },
  []
)

const rulesLoaded = handleActions(
  {
    [actions.fetchRulesSuccess]: () => true,
    [actions.fetchRulesPending]: () => false,
  },
  false
)

const rulesLoading = handleActions(
  {
    [actions.fetchRulesPending]: () => true,
    [actions.fetchRulesSuccess]: () => false,
  },
  true
)

const onCall = handleActions(
  {
    [actions.fetchRulesSuccess]: (state, action) => {
      return action.payload.onCall
    },
  },
  {}
)

const activeRule = handleActions(
  {
    [constants.EDIT_RULE]: (state, action) => ({ ...state, loading: false, data: action.rule }),
    [constants.RESET_ACTIVE_RULE]: () => _.cloneDeep(newRuleModel),
    [constants.RESET_ACTIVE_RULE_ACTION]: (state) => {
      const newState = _.cloneDeep(state)
      newState.data.item.action = participantAction
      return newState
    }
  },
  _.cloneDeep(newRuleModel)
)

const userIdsForRules = handleActions(
  {
    [actions.fetchRulesSuccess]: (state, action) => {
      const flatRules = action.payload.rules
      return _(flatRules)
        .map(rule => {
          if (rule.action.type === constants.ACTION_TYPES.PARTICIPANT) {
            return rule.action.options.userIds
          }
        })
        .flatten()
        .uniq()
        .map(id => +id)
        .value()
    },
  },
  []
)

const roundRobinStatusByKey = handleActions(
  {
    [actions.fetchRoundRobinByKey]: (state, action) => {
      return state.set(action.payload.roundRobinKey, Map({
        loaded: false,
        loading: false,
        data: null,
        err: null,
      }))
    },
    [actions.fetchRoundRobinByKeyPending]: (state, action) => {
      return state.setIn([action.payload.roundRobinKey, 'loading'], true)
    },
    [actions.fetchRoundRobinByKeyFailed]: (state, action) => {
      return state
        .setIn([action.payload.roundRobinKey, 'loading'], false)
        .setIn([action.payload.roundRobinKey, 'loaded'], false)
        .setIn([action.payload.roundRobinKey, 'err'], action.payload.err)
        .setIn([action.payload.roundRobinKey, 'data'], null)
    },
    [actions.fetchRoundRobinByKeySuccess]: (state, action) => {
      return state
        .setIn([action.payload.roundRobinKey, 'loading'], false)
        .setIn([action.payload.roundRobinKey, 'loaded'], true)
        .setIn([action.payload.roundRobinKey, 'data'], action.payload.data)
        .setIn([action.payload.roundRobinKey, 'err'], null)
    },
  }
, Map())

export default combineReducers({
  rules,
  rulesLoading,
  onCall,
  activeRule,
  userIdsForRules,
  rulesLoaded,
  roundRobinStatusByKey,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/rules/reducer.js